<template>
  <div class="login-container">
    <div class="wrap">
      <h3 class="title">电仪EITPM决策管理平台</h3>
      <el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="login-form" status-icon>
        <el-form-item prop="username">
          <!-- <span class="svg-container iconfont icon-yonghu"></span> -->
          <span class="svg-container">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-user"></use>
            </svg>
          </span>
          <el-input name="username" type="text" v-model="loginForm.username" autoComplete="off" placeholder="账号"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <!-- <span class="svg-container iconfont icon-mima"></span> -->
          <span class="svg-container">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-lock"></use>
            </svg>
          </span>
          <el-input name="password" :type="pwdType" @keyup.enter.native="handleLogin" v-model="loginForm.password" autoComplete="off" placeholder="密码"></el-input>
        </el-form-item>
        <p class="notice"> {{errMessage}} </p>
        <el-form-item class="loginBtn">
          <el-button type="primary" style="width:100%;height:50px;" :loading="loading" @click.native.prevent="handleLogin">登录</el-button>
        </el-form-item>
      </el-form>
    </div>   
  </div>
</template>

<script>
import "@/assets/iconfont/iconfont.js";
export default {
  name: "login",
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("用户名不能为空"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("密码不能为空"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: "",
        password: ""
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername }
        ],
        password: [{ required: true, trigger: "blur", validator: validatePass }]
      },
      loading: false,
      pwdType: "password",
      errMessage: ""
    };
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            username: this.loginForm.username,
            password: this.loginForm.password
          };
          this.$axios
            .post("users/login", data)
            .then(res => {
              this.loading = false;
              // sessionStorage.setItem('token', JSON.stringify(res.data.data.token));
              // this.$axios.defaults.headers.common['Authorization'] = 'Bearer '+res.data.data.token;
              sessionStorage.setItem("userInfo", JSON.stringify(res.data.data));
              this.setToken(res.data.data.token);
              sessionStorage.setItem("loginWay", "legacy");
              if (this.$route.query.redirect == location.hostname) {
                this.$router.go(-1);
              } else {
                this.$router.push({ name: "equipmentSituation" });
              }
            })
            .catch(err => {
              this.loading = false;
              this.errMessage = err.response.data.message;
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
/* 修复input 背景不协调 和光标变色 */
$bg: #283443;
$light_gray: #333;
$cursor: #333;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
    // &::first-line {
    // color: $light_gray;
    // color: #fff;
    // }
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;
      &:-webkit-autofill {
        // -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }
  .el-form-item {
    border: 1px solid #dedede;
    background: transparent;
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss">
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #fff;

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.login-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: url(../../assets/images/login_bg.jpg) no-repeat center top;
  background-size: cover;
  background-attachment: fixed;
  input:-webkit-autofill {
    -webkit-text-fill-color: #fff !important;
  }

  input {
    background: transparent;
    border: 0px;
    -webkit-appearance: none;
    border-radius: 0px;
    padding: 12px 5px 12px 15px;
    color: #333 !important;
    height: 47px;
  }
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: #999;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    &_login {
      font-size: 20px;
    }
    font-size: 22px;
  }
  .title {
    font-size: 28px;
    font-weight: 400;
    color: $light_gray;
    margin: 0px auto 40px auto;
    text-align: center;
  }
  .wrap {
    position: absolute;
    left: 0;
    right: 0;
    width: 440px;
    margin: 170px auto;
  }
  .login-form {
    padding: 50px 40px 20px 40px;
    border-radius: 10px;
    background-color: #fff;
  }
  .el-form-item {
    border: 1px solid #dedede;
    background: transparent;
    border-radius: 5px;
    color: #454545;
    width: 360px;
    &.loginBtn {
      border: none;
      margin-top: 50px;
    }
  }
  .el-form-item__error {
    color: #ff0000;
  }
  .notice {
    color: #ff0000;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue